import { AuthState, AUTH_FEATURE_KEY } from "./auth.reducer";
import { createFeatureSelector, createSelector } from "@ngrx/store";

export const getAuthFeatureState = createFeatureSelector<AuthState>(AUTH_FEATURE_KEY);

export const selectIsAuthenticated = createSelector(getAuthFeatureState, (state: AuthState) => state.authenticated);

export const selectIsFailure = createSelector(getAuthFeatureState, (state: AuthState) => state.error);

export const selectUserInfo = createSelector(getAuthFeatureState, (state: AuthState) => state.profile);
